(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    

  window.addEventListener('scroll', function () {
    const scrollY = window.scrollY || window.pageYOffset;
    const body = document.body;

    if (scrollY > 20) {
      body.classList.add('scrolled-down');
    } else if (scrollY === 0) {
      body.classList.remove('scrolled-down');
    }
  });

  
  (() => {
    const headerElement = document.getElementById('shopify-section-header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  })();


  } catch(e) { console.error(e); }
})();
})();
